var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Team Management","items":_vm.items,"doc":_vm.doc,"loading":_vm.loading}},[_c('Integration',{staticClass:"my-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }